import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const getConnectedAccountByUserId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_STRIPE_ACCOUNT_BY_USERID}?userId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getConnectedAccountByEventId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_STRIPE_ACCOUNT_BY_EVENTID}?eventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getPaymentDetailsById = async (id, part) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_STRIPE_PAYMENT_BY_ID}?Id=${id}&part=${part}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getConnectedAccount = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_STRIPE_CONNECTED_ACCOUNT}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getPaymentIntent = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_STRIPE_PAYMENT_INTENT}?Id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const createConnetedAccount = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.CREAT_STRIPE_ACCOUNT}?userId=${data}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const deleteConnetedAccount = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.DELETE_STRIPE_ACCOUNT_BY_USERID,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const createLinkAccount = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CREAT_STRIPE_LINK,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const createCheckoutSession = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CREAT_STRIPE_CHECKOUT_SESSION,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const capturePaymentIntent = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CAPTURE_STRIPE_PAYMENT_INTENT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const createPaymentIntent = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CREAT_STRIPE_PAYMENT_INTENT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const createTicketPaymentIntent = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CREATE_STRIPE_TICKET_PAYMENT_INTENT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const confirmPaymentIntent = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CONFIRM_STRIPE_PAYMENT_INTENT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const saveTicketPayment = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CONFIRM_STRIPE_TICKET_PAYMENT_INTENT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const webhook = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.STRIPE_WEBHOOK, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const savePaymentDetails = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.SAVE_PAYMENT, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updatePaymentDetails = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.UPDATE_PAYMENT, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const capturePaymentByAppId = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CAPTURE_PAYMENT_BY_APP_ID,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const cancelPaymentByAppId = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.CANCEL_PAYMENT_BY_APP_ID,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getPaymentStatusByAppId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_APP_PAYMENT_STATAU_BY_ID}?Id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const saveBankPaymentDetails = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.SAVE_BANK_PAYMENT, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
